import React, { Component } from 'react';
import { TextBox } from 'devextreme-react';
import i18n from '../../i18n';
import { URL_PATTERN } from '../../constants/Config';
import ReeValidate from 'ree-validate';
import vi from 'ree-validate/dist/locale/vi';
import en from 'ree-validate/dist/locale/en';
import PropTypes from 'prop-types';

class URLBox extends Component {
    constructor(props) {
        super(props);

        this.validator = new ReeValidate({
            url: this.props.validatorValue
        });

        if (this.props.currentLanguage === 'vi-VN') {
            this.validator.localize('vi', vi);
        } else {
            this.validator.localize('en', en);
        }

        this.validator.validate('url', this.props.value).then(() => {
            this.checkValidate();
        });

        this.valueChanged = this.valueChanged.bind(this);
    }

    valueChanged = (e) => {
        const { useCustomValidator } = this.props;
        if (e.event !== undefined && e.event !== null) {
            if (e.event.type !== 'dxclick') {
                const { errors } = this.validator;
                const value = e.event.target.value;

                errors.remove(e.event.target.name);
                this.props.updateData({
                    [this.props.field]: value
                });

                if (useCustomValidator === undefined || useCustomValidator === false) {
                    this.validator
                        .validate(e.event.target.name, value)
                        .then(() => {
                            this.checkValidate();
                        })
                        .catch(() => { });
                } else {
                    // this.checkCustomValidate(value)
                }
            }
        }
    };

    checkCustomValidate = (value) => {
        const { field } = this.props;
        const checkValidate = URL_PATTERN.test(value);
        if (value === '#') {
            this.props.updateData({
                formValidate: { [field]: true }
            });
        } else {
            this.props.updateData({
                formValidate: { [field]: checkValidate }
            });
        }
    }

    checkValidate() {
        const { field } = this.props;

        const formValidate = !this.validator.errors.has('url');

        this.props.updateData({
            formValidate: { [field]: formValidate }
        });
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            if (this.props.useCustomValidator) {
                // this.checkCustomValidate(nextProps.value)
            } else {
                this.validator.validate('url', nextProps.value).then(() => {
                    this.checkValidate();
                });
            }
        }

        if (nextProps.validatorValue !== this.props.validatorValue) {
            this.validator = new ReeValidate({
                url: nextProps.validatorValue
            });
            this.validator.validate('url', nextProps.value).then(() => {
                this.checkValidate();
            });
        }
    }

    render() {
        const { value, i18nLabel, validatorValue, useCustomValidator, readOnly } = this.props;

        return (
            <div
                className={
                    '' + ((this.validator.errors.has('url') && !useCustomValidator) ? ' has-error' : '')
                }
            >
                <div className={'dx-field'}>
                    <div className={'dx-field-label'}>
                        {i18n.t(i18nLabel) + ':'}
                        {/* {
                            bannerType !== undefined && bannerType !== 0 &&
                            <span className="color-red"> *</span>
                        } */}
                        {validatorValue &&
                            validatorValue.includes('require') && (<span className="color-red"> *</span>)}
                    </div>

                    <div className={'dx-field-value'}>
                        <TextBox
                            className={'multi-language'}
                            name={'url'}
                            value={value}
                            readOnly={readOnly || false}
                            onValueChanged={this.valueChanged}
                        />

                        {this.validator.errors.has('url') && !useCustomValidator && (
                            <div className="help-block">
                                {this.validator.errors
                                    .first('url')
                                    .replace('url', i18n.t(i18nLabel))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

URLBox.propTypes = {
    validatorValue: PropTypes.string,
    value: PropTypes.string,
    i18nLabel: PropTypes.string,
    useCustomValidator: PropTypes.string,
    readOnly: PropTypes.bool,
    updateData: PropTypes.func,
    field: PropTypes.string,
    currentLanguage: PropTypes.string
};

export default URLBox;
